import * as Types from "../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateCurrencyBookMutationVariables = Types.Exact<{
  id: Types.Scalars["Int"];
  name: Types.Scalars["String"];
  currency_id: Types.Scalars["Int"];
  business_unit_id: Types.Scalars["Int"];
}>;

export type UpdateCurrencyBookMutation = { __typename?: "mutation_root" } & {
  update_currency_books?: Types.Maybe<
    { __typename?: "currency_books_mutation_response" } & {
      returning: Array<
        { __typename?: "currency_books" } & Pick<
          Types.Currency_Books,
          "id" | "name" | "currency_id" | "business_unit_id"
        >
      >;
    }
  >;
};

export const UpdateCurrencyBookDocument = gql`
  mutation UpdateCurrencyBook(
    $id: Int!
    $name: String!
    $currency_id: Int!
    $business_unit_id: Int!
  ) {
    update_currency_books(
      where: { id: { _eq: $id } }
      _set: {
        name: $name
        currency_id: $currency_id
        business_unit_id: $business_unit_id
      }
    ) {
      returning {
        id
        name
        currency_id
        business_unit_id
      }
    }
  }
`;

export function useUpdateCurrencyBookMutation() {
  return Urql.useMutation<
    UpdateCurrencyBookMutation,
    UpdateCurrencyBookMutationVariables
  >(UpdateCurrencyBookDocument);
}
